import { useEffect } from 'react'

import { $createQuoteNode, $isQuoteNode } from '@lexical/rich-text'
import {
  $createLineBreakNode,
  $getSelection,
  $insertNodes,
  COMMAND_PRIORITY_EDITOR,
  LexicalNode
} from 'lexical'

import { useEditor } from '../../hooks/useEditor'

import { INSERT_QUOTE_COMMAND } from './commands'

export const QuotePlugin = () => {
  const editor = useEditor()

  useEffect(() => {
    return editor.registerCommand(
      INSERT_QUOTE_COMMAND,
      () => {
        const paragraphNode = $createQuoteNode()
        const nodes: LexicalNode[] = [paragraphNode]
        const selection = $getSelection()
        if (selection?.extract().some($isQuoteNode)) {
          nodes.unshift($createLineBreakNode())
        }
        $insertNodes(nodes)
        return true
      },
      COMMAND_PRIORITY_EDITOR
    )
  }, [editor])

  return null
}
